<div  *ngIf="isLoading" class="overlay overlay-block cursor-default modal-body">
    <ng-container>
        <div class="overlay-layer bg-transparent">
            <div class="spinner spinner-lg spinner-success"></div>
        </div>
    </ng-container>
</div>  

<div *ngIf="!isLoading" class="mat-elevation-z0 navBox">
    <div class="custom-slider">
        <mat-accordion [multi]="true">

            <mat-expansion-panel [expanded]="true" class="mat-elevation-z0">
                <mat-expansion-panel-header class="mb-4">
                    <mat-panel-title>
                        <h6>ALLGEMEIN</h6>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-slide-toggle 
                    [checked]="nurAufLager" 
                    [color]="'warn'"
                    (change)="onIsNurAuflagerChanged($event)"
                    matTooltip="Nur Artikel auf Lager anzeigen.">
                    Nur Artikel auf Lager
                </mat-slide-toggle>
            </mat-expansion-panel>

            <mat-expansion-panel *ngIf="maxPreis > 0 && maxPreis >= minPreis" [expanded]="true" class="mat-elevation-z0">
                <mat-expansion-panel-header class="mb-4">
                    <mat-panel-title>
                        <h6>PREIS</h6>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <ngx-slider 
                    class="theme-customer"
                    [(value)]="minPreis" 
                    [(highValue)]="maxPreis" 
                    [options]="options"
                    (userChangeEnd)="onValuePreisChanged($event)">
                </ngx-slider>
            </mat-expansion-panel>
            <div *ngIf="isPreisFilter" class="mt-0" align="right">
                <button mat-icon-button (click)="removePriceFilter()" color="warn" aria-label="Clear Filter Price" matTooltip="Preisfilter entfernen">
                    <mat-icon class="matIcon">clear</mat-icon>
                </button>
            </div>

            <!-- TODO: activate as soon as filtering by Grösse and Farbe is possible and makes sense -->

            <mat-expansion-panel *ngIf="isGroessenAvailable" [expanded]="_filterGroessen.length > 0" class="mat-elevation-z0">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <h6>GRÖSSEN</h6>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="content-container mt-4 class_maxheight500" fxLayout="column" fxLayoutAlign="stretch" fxFlex="auto">
                    <perfect-scrollbar class="scroll-container theme-customer" fxFlex="auto" [config]="config" [scrollIndicators]="true" style="max-height: 200px;">
                        <div class="scrollable-content">
                            <div *ngFor="let groesse of groessen" class="mb-2">
                                <mat-checkbox #cbGroesse [value]="groesse" [checked]="groesse.selected" [color]="'warn'" (change)="getGroesse($event, groesse)">
                                    {{groesse.groesse_Wert}}
                                </mat-checkbox>
                            </div>
                        </div>
                    </perfect-scrollbar>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel *ngIf="isFarbenAvailable" [expanded]="_filterFarben.length > 0" class="mat-elevation-z0">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <h6>FARBEN</h6>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="content-container mt-4 class_maxheight500" fxLayout="column" fxLayoutAlign="stretch" fxFlex="auto">
                    <perfect-scrollbar class="scroll-container theme-customer" fxFlex="auto" [config]="config" [scrollIndicators]="true" style="max-height: 200px;">
                        <div class="scrollable-content">
                            <div *ngFor="let farbe of farben" class="mb-2">
                                <mat-checkbox #cbFarbe [value]="farbe" [checked]="farbe.selected" [color]="'warn'" (change)="getFarbe($event, farbe)">
                                    {{farbe.farbe_Wert}}
                                </mat-checkbox>
                            </div>
                        </div>
                    </perfect-scrollbar>
                </div>
            </mat-expansion-panel>

            <div *ngIf="isMerkmalGruppenAvailable">
                <mat-expansion-panel *ngFor="let merkmalGruppe of merkmalGruppen" [expanded]="merkmalGruppe.isActive" class="mat-elevation-z0" [hidden]="(merkmalGruppe.name).toUpperCase()=='WS-STARTSEITE' ? true : false">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <h6>{{merkmalGruppe.name | uppercase}}</h6>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="content-container mt-4" fxLayout="column" fxLayoutAlign="stretch" fxFlex="auto">
                        <perfect-scrollbar class="scroll-container theme-customer" fxFlex="auto" [config]="config" [scrollIndicators]="true" style="max-height: 200px;">
                            <div class="scrollable-content">
                                <div *ngFor="let merkmal of merkmalGruppe.merkmale" class="mb-2">
                                    <mat-checkbox #cbFarbe [value]="merkmal.id" [checked]="merkmal.selected" [color]="'warn'" (change)="getMerkmal($event, merkmal)">
                                        {{merkmal.text}}
                                    </mat-checkbox>
                                </div>
                            </div>
                        </perfect-scrollbar>
                    </div>
                </mat-expansion-panel>
            </div>

        </mat-accordion>
    </div>
</div>